import * as pako from "pako";

/**
 * decode base64 encoding and decompress
 * @param base64encodedData
 */
export function decompress(base64encodedData: string, options: pako.InflateOptions = {}) {
  let decodedData: Uint8Array[] = [];
  try {
    // we got the model, return it:
    decodedData = decodeBase64InChunks(base64encodedData);
  } catch (error) {
    console.error("could not decode non-base64-data", error);
    return base64encodedData;
  }

  // decompress data
  try {
    const inflator = new pako.Inflate(options);
    decodedData.forEach(chunk => inflator.push(chunk, false));
    inflator.push(new Uint8Array(), true);
    if (inflator.err) {
      throw new Error(`Decompression error: ${inflator.err}`);
    }
    const decompressed = inflator.result;
    const decoder = new TextDecoder("utf-8");
    return decoder.decode(decompressed);
  } catch (error) {
    console.error("could not decompress data", error);
    throw new Error("Decompression failed");
  }
}

function decodeBase64InChunks(base64String: string, chunkSize = 1024 * 1024) {
  const decodedByteChunks: Uint8Array[] = [];
  let decodedBytes: number[] = [];
  const ARRAY_CHUNK_SIZE = 65536; // 64KB

  for (let i = 0; i < base64String.length; i += chunkSize) {
    const chunk = base64String.slice(i, i + chunkSize);
    const decodedChunk = atob(chunk);
    for (let j = 0; j < decodedChunk.length; j++) {
      decodedBytes.push(decodedChunk.charCodeAt(j));
      if (decodedBytes.length >= ARRAY_CHUNK_SIZE) {
        decodedByteChunks.push(new Uint8Array(decodedBytes));
        decodedBytes = [];
      }
    }
  }
  if (decodedBytes.length > 0) {
    decodedByteChunks.push(new Uint8Array(decodedBytes));
  }

  return decodedByteChunks;
}

/**
 * create a blob with zipped, base64-encoded data
 * @returns a blob containing the data
 */
export function compressToBlob(data: string) {
  const compressed = compress(data);

  const blob = new Blob([compressed], {
    type: "text/plain"
  });
  return blob;
}

export function compress(data: string): string {
  const textencoder = new TextEncoder();
  const encoded = textencoder.encode(data);
  const uintArray = pako.deflate(encoded);
  const string = uintArrayToString(uintArray);
  const base64 = btoa(string);

  return base64;
}

function uintArrayToString(uintArray: Uint8Array): string {
  // return new TextDecoder('latin1').decode(uintArray);
  const CHUNK_SIZE = 65536; // 64KB chunks to avoid call stack overflow
  let result = '';
  
  for (let i = 0; i < uintArray.length; i += CHUNK_SIZE) {
    const chunk = uintArray.subarray(i, i + CHUNK_SIZE);
    result += String.fromCharCode(...chunk);
  }
  
  return result;
}

export default {
  decompress,
  compressToBlob,
  compress
};
